<bn-loading-overlay></bn-loading-overlay>

<div class="row">
    <div class="col">
        <h3>Solicitação para devolução de valor honrado a recuperar</h3>
    </div>

    <div class="col-auto">
        <button type="button" class="btn btn-primary" (click)="voltarParaLista()">Voltar</button>

        <button *ngIf="podeEnviarSolicitacaoDevolucao && modoEdicao" type="button" class="btn btn-primary"
            [disabled]="false" (click)="verificaTermos()">Enviar
        </button>
    </div>
</div>
<div class="container">
    <div class="row">

        <div class="col-md-6 bn-form-group">
            <label><b>Agente Financeiro:</b></label>
            <select class="form-select" name="idAgenteFinanceiro"
                [(ngModel)]="solicitacaoDevolucao.cnpjAgenteFinanceiro" [disabled]="usuarioAgenteFinanceiro">
                <option [ngValue]=agente.cnpj *ngFor="let agente of agentesFinanceiros">
                    {{ agente.nome }}
                </option>
            </select>
        </div>

        <div class="col-md-3">
            <label><b>Sistema: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                        ngbTooltip="Sistema do contrato, constante dos Boletos de Cobrança enviados pelo BNDES, ou Crédito Livre."></i></b>
            </label>
            <select class="form-select" (change)="atribuiSistema($event.target.value)" [disabled]="!modoEdicao"
                [(ngModel)]="sistemaSelecionado">
                <option value='CL'>Crédito Livre</option>
                <option value='15'>15 - FINAME</option>
                <option value='89'>89 - BNDES</option>
            </select>
        </div>

        <div class="col-md-3 bn-form-group" *ngIf="!solicitacaoDevolucao.sistemaRepasse">
            <label>Id. externo operação: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Identificador do protocolo da operação informado pelo Agente Financeiro."></i>
            </label>

            <input type="text" class="form-control" [(ngModel)]="solicitacaoDevolucao.idOperacaoExterno" required
                pattern="[a-zA-Z0-9\-_]{1,20}" [disabled]="!modoEdicao">
        </div>

        <div class="col-md-3"
            *ngIf="solicitacaoDevolucao.sistemaRepasse == '15' || solicitacaoDevolucao.sistemaRepasse == '89'">
            <label>Contrato: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
                    ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i>
            </label>
            <input type="text" class="form-control" [(ngModel)]="solicitacaoDevolucao.contratoRepasse" required
                pattern="[0-9]{11}" [disabled]="!modoEdicao">
        </div>
    </div>

</div>